import {
  AspectRatio,
  forwardRef,
  Heading,
  HTMLChakraProps,
  Image,
  Skeleton,
  SkeletonText,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { FC } from 'react';

import { ProfilePopupNew } from '@/components/ui/shared/profile/ProfilePopup/ProfilePopupNew';
import { ThinProfile } from '@/resources/ThinProfile';

import { SpeakerCardContainer } from './elements';

export interface ISpeakerCardProps extends HTMLChakraProps<'div'> {
  profile: ThinProfile;
  showImage?: boolean;
}

export const SpeakerCard = forwardRef<ISpeakerCardProps, 'div'>((props, ref) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { profile, showImage = true, ...rest } = props;

  return (
    <SpeakerCardContainer onClick={onOpen} ref={ref} {...rest}>
      {showImage && (
        <AspectRatio maxW="full" ratio={1} mb="4">
          <Image
            src={profile.mediumSquareAvatarUrl || '/images/placeholderSquareSpeaker.png'}
            alt={profile.fullName}
            fallback={<Skeleton />}
          />
        </AspectRatio>
      )}

      <Heading as="h3" mb="3" fontSize="xl" lineHeight="7">
        {profile.fullName}
      </Heading>

      <Text noOfLines={6} fontSize="sm" lineHeight="5" color="gray.800">
        {profile.title}
      </Text>
      <ProfilePopupNew isOpen={isOpen} onClose={onClose} profiles={[profile]} />
    </SpeakerCardContainer>
  );
});

export const SpeakerCardSkeleton: FC<HTMLChakraProps<'div'>> = (props) => {
  return (
    <SpeakerCardContainer {...props}>
      <AspectRatio maxW="full" ratio={1} mb="4">
        <Skeleton />
      </AspectRatio>

      <SkeletonText noOfLines={2} skeletonHeight="5" spacing="2" py="1" mb="3" />
      <SkeletonText noOfLines={6} skeletonHeight="0.875rem" spacing=".375em" py=".1875em" />
    </SpeakerCardContainer>
  );
};
